import history from "../history";

const PushHistory = (path, newTab, state) => {
  newTab
    ? window.open(path, "_blank")
    : history.push({ pathname: path, state });
};

export default PushHistory;
